export default "__VITE_ASSET__BHndgKvS__"